export default "__VITE_ASSET__79536bcf__"